###
  Campaign frequency capping
###

class INTENT.widgets.FrequencyCapping

  @ATTR_NAME: "data-widget-frequency-capping"

  fc_types: []

  constructor: (@el) ->
    @s = @.constructor
    @attr = @s.ATTR_NAME
    @code = @attr.replace 'data-', ''

    @can_edit = @el.data "#{@code}-can-edit"

    @fc_types = @el.data "#{@code}-types"
    @fc_values = @el.data "#{@code}-values"
    if !@fc_values
      @fc_values = {
        'hour': 2
      }

    for type, value of @fc_values
      @add_input_group type, value

    @update_available_options()

    @el.on 'click', "[#{@attr}-remove]", (e) =>
      e.preventDefault()
      self = $(e.target)
      group = self.closest("[#{@attr}-group]")
      if group.length
        group.find('select').destroySelect2()
        self.tooltip('destroy')
        group.remove()
        @update_available_options()

      unless $("[#{@attr}-remove]").length
        @toggle_strict false

    @el.on 'click', "[#{@attr}-add]", (e) =>
      e.preventDefault()
      self = $(e.target)
      if self.attr('disabled')
        return false

      @add_input_group()
      @update_available_options()

    @el.on 'change', "[#{@attr}-type]", (e) =>
      @update_available_options()

  add_input_group: (selected_type = false, input_value = '') =>
    index = 0
    while @el.find("[#{@attr}-group='#{index}']").length > 0
      index++

    newGroup = @get_input_group_template(index, selected_type, input_value)
    lastGroup = @el.find("[#{@attr}-group]:last")
    if lastGroup.length
      lastGroup.after newGroup
    else
      @el.prepend newGroup

    @toggle_strict true

  update_available_options: =>
    fc_used = {}
    for key, type of @fc_types
      fc_used[type] = false

    @el.find("[#{@attr}-type]").each (key, item) =>
      item = $(item)
      item_type = item.val()
      fc_used[item_type] = true

    fc_available = []
    for key, type of @fc_types
      if !fc_used[type]
        fc_available.push type

    @el.find("[#{@attr}-type]").each (select_key, select) =>
      select = $(select)
      select_val = select.val()
      select.find('option').each (option_key, option) =>
        option = $(option)
        option_val = option.val()
        if !option_val || option_val == select_val || fc_available.indexOf(option_val) != -1
          option.removeAttr 'disabled'
        else
          option.attr 'disabled', 'disabled'

    groups_count = $("[#{@attr}-group]").length
    add_button = @el.find "[#{@attr}-add]"
    if fc_available.length and groups_count < @fc_types.length
      add_button.removeClass 'disabled'
    else
      add_button.addClass 'disabled'

    init_select2()

  get_input_group_template: (index, selected_type = false, input_value = '') ->
    action_remove = ""
    if @can_edit
      action_remove = """
        <div class="#{@code}-remove">
          <i class="fa fa-times opacity-dynamic" #{@attr}-remove></i>
        </div>
      """

    """
    <div class="#{@code}-group col-sm-8" #{@attr}-group="#{index}">
      <div class="col-sm-5">
        <select class="form-control select2-init"
          name="targeting[frequency_capping][type][#{index}]"
          #{@attr}-type="#{index}"
        >
          #{ @get_select_options_template(selected_type) }
        </select>
      </div>
      <div class="col-sm-6">
        <input type="text" class="form-control numbers-only"
          name="targeting[frequency_capping][value][#{index}]"
          value="#{input_value}"
          placeholder="#{__('campaign.frequency-capping.input-placeholder')}"
          #{@attr}-value="#{index}">
      </div>
      #{ action_remove }
    </div>
    """

  get_select_options_template: (selected_type = false) ->
    options = "<option value='' selected='selected'>...</option>"
    if !!selected_type
      options = "<option value=''>...</option>"

    for key, type of @fc_types
      title = __('campaign.frequency-capping.per.' + type)
      if type is selected_type
        options += "<option value='#{type}' selected='selected'>#{title}</option>"
      else
        options += "<option value='#{type}'>#{title}</option>"

    return options

  toggle_strict: (show = true) ->
    strict = $('#frequency_capping-strict').closest '.form-group'
    if show
      strict.show();
    else
      strict.hide();
